import gettingRestClientObject from '../../../../services/utils/cms-helper'
// import { _ } from 'vue-underscore';
var gettingRestClient = gettingRestClientObject();
const state = {
   products: [],
   subProducts: [],
   filterValues: [],
   filterProducts: [],
   productCategories: [],
   category: ''
}

// getters
const getters = {
   products: state => {
      return state.products
   },
   subProducts: state => {
      return state.subProducts
   },
   selectedFilterValue: state => {
      return state.filterValues
   },
   selectedFilterProducts: state => {
      return state.filterProducts.filter((x) => {
         return (
            x.sellingPrice >= (state.filterValues[0]) &&
            x.sellingPrice <= (state.filterValues[1])
         );
      });
   },
   selectedFilterProductsLength: (state, getters) => {
      return getters.selectedFilterProducts.length
   },
   categorySelected: state => {
      if (state.category) {
         var category = state.productCategories.filter((x) => {
            return x.Category_ID.toLowerCase() == state.category.toLowerCase();
         });
         if (category.length) {
            return category[0];
         } else {
            return [];
         }
      } else {
         return [];
      }
   },
   productCategories: state => {
      return state.productCategories
   },

}

// actions 
const actions = {
   getProducts(context) {
      context.commit('getProductCategories');
      context.commit('getProductsHandler');

   },
   setfilterValues(context, payload) {
      context.commit('setfilterValues', payload)
   },
   filterProducts(context, payload) {
      context.commit('filterProducts', payload);
      context.commit('categorySelectedUpdate', payload.category);
   },
}

// mutations
const mutations = {
   getProductsHandler: (state) => {
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
         pageType: "Master Table/",
         pageUrl: "Product List/Product List/Product List.ftl",
         lang: language,

         successCallback: function (response) {
            var productData = response.data;
            if (productData != undefined && productData.Values != undefined) {
               state.products = [];
               state.subProducts = [];

               productData = productData.Values.filter(function (el) {
                  return !el.Is_Sub_Type && el.Is_Active;
               });
               var subProduct = response.data.Values.filter(function (el) {
                  return el.Is_Sub_Type && el.Is_Active;
               });

               productData.forEach(element => {
                  if (element.Category_ID) {
                     var item = state.productCategories.find(ele => {
                        return ele.Category_ID.trim() === element.Category_ID.trim()
                     });
                     element.Category_Name = item.Category_Name;
                  }
                  if (element.Discount_Percentage) {
                     var price = element.Price - (element.Price * element.Discount_Percentage / 100);
                     element.sellingPrice = Number(price);
                  } else {
                     element.sellingPrice = Number(element.Price);
                  }
               });

               subProduct.forEach(element => {
                  if (element.Category_ID) {
                     var item2 = state.productCategories.find(ele => {
                        return ele.Category_ID.trim() === element.Category_ID.trim()
                     });
                     element.Category_Name = item2.Category_Name;
                  }
                  if (element.Discount_Percentage) {
                     var price = element.Price - (element.Price * element.Discount_Percentage / 100);
                     element.sellingPrice = Number(price);
                  } else {
                     element.sellingPrice = Number(element.Price);
                  }
               });
               state.products = productData;
               state.subProducts = subProduct;
            }
            else {
               state.products = []
            }
         },
         errorCallback: function (error) {
            state.products = []
            console.log(error);
         }
      };
      gettingRestClient.cmsRequest(config);
   },
   getProductCategories(state) {
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
         pageType: "Template/",
         pageUrl: "24 Configuration/24 Configuration/24 Configuration.ftl",
         lang: language,

         successCallback: function (response) {
            var res = response.data;
            if (res.area_List) {
               var categoryArea = gettingRestClient.pluck(
                  "Category",
                  res.area_List
               );
               var categoryListTemp = gettingRestClient.getAllMapData(
                  categoryArea[0].component
               );
               if (categoryListTemp.Category_List) {
                  state.productCategories = categoryListTemp.Category_List;
               }
            }
         },
         errorCallback: function (error) {
            console.log(error);
         },
      };
      gettingRestClient.cmsRequest(config, language);
   },
   setfilterValues: (state, payload) => {
      state.filterValues = payload;
   },
   filterProducts(state, payload) {
      state.filterProducts = []
      state.filterProducts = state.products.filter((x) => {
         return (
            (x.Category_ID.trim()).includes(payload.category) &&
            (x.Sub_Category_ID.trim()).includes(payload.subCategory)
         );
      });
      var lowestPrice = Math.min.apply(Math, state.filterProducts.map(function (o) { return o.sellingPrice; }));
      var highestPrice = Math.max.apply(Math, state.filterProducts.map(function (o) { return o.sellingPrice; }));

      console.log("low", lowestPrice, "high", highestPrice)
      if (isFinite(lowestPrice) && isFinite(highestPrice)) {
         if (highestPrice == lowestPrice) {
            highestPrice = parseFloat(highestPrice) + 1;
            console.log("low", lowestPrice, "high", highestPrice)

         }
         state.filterValues = [lowestPrice, highestPrice];
      } else {
         state.filterValues = [0, 1];
      }

   },
   categorySelectedUpdate(state, payload) {
      state.category = payload;
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}
